import { useEffect, useMemo } from 'react';
import { CssBaseline, ThemeProvider as MUIThemeProvider } from '@mui/material';
import { useThemeStore } from '../../../store/themeStore';
import { getTheme } from '../../theme';

const getResolvedMode = (mode) => {
  if (mode !== 'system') return mode;
  if (typeof window === 'undefined' || !window.matchMedia) return 'light';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

const ThemeProvider = ({ children }) => {
  const mode = useThemeStore((s) => s.mode);
  const setTheme = useThemeStore((s) => s.setTheme);

  const resolvedMode = useMemo(() => getResolvedMode(mode), [mode]);

  useEffect(() => {
    const html = document.documentElement;
    html.setAttribute('data-theme', resolvedMode);
  }, [resolvedMode]);

  useEffect(() => {
    if (!window.matchMedia) return;
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = () => {
      if (useThemeStore.getState().mode === 'system') {
        // trigger rerender via updating mode to same value
        setTheme('system');
      }
    };
    mql.addEventListener?.('change', handler);
    return () => mql.removeEventListener?.('change', handler);
  }, [setTheme]);

  const theme = useMemo(
    () =>
      getTheme(resolvedMode),
    [resolvedMode]
  );

  return (
    <MUIThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MUIThemeProvider>
  );
};

export default ThemeProvider;


